import { Routes } from '@angular/router';

export const STATIC_PAGES_ROUTES: Routes = [
  {
    path: 'privacy',
    loadComponent: () =>
      import('./pages/privacy-page/privacy-page.component').then(m => m.PrivacyPageComponent)
  },
  {
    path: 'terms',
    loadComponent: () =>
      import('./pages/terms-page/terms-page.component').then(m => m.TermsPageComponent)
  },
  {
    path: 'cookies',
    loadComponent: () =>
      import('./pages/cookies-page/cookies-page.component').then(m => m.CookiesPageComponent)
  },
  {
    path: 'about',
    loadComponent: () =>
      import('./pages/about-page/about-page.component').then(m => m.AboutPageComponent)
  }
];
